import { Spinner } from 'flowbite-react';

interface LoadingProps {
  message?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullScreen?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  message = 'Loading...',
  size = 'lg',
  fullScreen = false
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center py-12">
      <Spinner
        aria-label={message}
        size={size}
        color="info"
      />
      <p className="mt-4 text-gray-600 dark:text-gray-400">{message}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white dark:bg-gray-900 bg-opacity-90 dark:bg-opacity-90 flex items-center justify-center z-50">
        {content}
      </div>
    );
  }

  return content;
};